// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 237) return "js/237-dbc827f06bc5b29ffd42.js";
	// return url for filenames based on template
	return "js/" + chunkId + "-" + "f7589f606f7cf9f4d241" + ".chunk.js";
};